import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mukk4ka83q: FaireBrandEntity = {
  token: "b_mukk4ka83q",
  type: "brand",
  name: "The Penny Candy Store",
  avatarUrl:
    "https://cdn.faire.com/fastly/e8db9e8e10b9544c7933e5e0764368f26824993e10c54cf3c21dc128ce5224c4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c7509372e5729d361db815e4f9ef0924a8dc87d38ea6a27405c5466037e278a9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e8db9e8e10b9544c7933e5e0764368f26824993e10c54cf3c21dc128ce5224c4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c7509372e5729d361db815e4f9ef0924a8dc87d38ea6a27405c5466037e278a9.jpeg",
  location: "Sharon, MA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 172,
  isTopShop: true,
  isInsider: true,
  description:
    "The Penny Candy Store brings back everyone's favorite old fashioned and modern candy. Our goal is to bring our customers the freshest superior quality candy. We repackage candy from around the world in many different sizes depending on the retailers desired price point of their customers. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.664Z",
    importedBy: "entity-db-cli",
  },
};
